module.exports = __webpack_public_path__ + "img/hr-dry-tree-01.393ca0fb.png";